





















import { Component, Prop, Vue, namespace } from 'nuxt-property-decorator'
import { mdiHeart, mdiHeartOutline } from '@mdi/js'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { IProductToFavourites } from '~/assets/interfaces/products'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'

const favouritesStore = namespace('favourites')

// Кнопка «в избранное» с состоянием из стора, по образцу
// product-add-to-compare-icon-button. Иконкой по умолчанию; text — кнопка
// с подписью (список товаров).
@Component({
  components: {
    ComponentFormButton,
    ComponentFormButtonIcon,
  },
})
export default class ComponentProductFavouriteButton extends Vue {
  @Prop({ type: Number, required: true }) readonly productId!: number

  @Prop({ type: [String, Number], default: 22 }) readonly size!: string | number
  @Prop({ type: Boolean, default: false }) readonly text!: boolean

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  private isLoading = false

  private get isInFavourites() {
    return this.favouritesItems.some((item) => item.id === this.productId)
  }

  private get icon() {
    return this.isInFavourites ? mdiHeart : mdiHeartOutline
  }

  private get label() {
    return this.isInFavourites
      ? 'Удалить из избранного'
      : 'Добавить в избранное'
  }

  private async toggle() {
    if (this.isLoading) {
      return
    }
    this.isLoading = true
    try {
      await this.toFavourites({ id: this.productId })
    } finally {
      this.isLoading = false
    }
  }
}
